
import SwiperWrapper from './modules/SwiperWrapper'
import NavBar from './modules/NavBar'
import Action from './modules/Action'

window.APP_MODULES = {
    NavBar,
    SwiperWrapper,
    Action,
}
